<div class="attribute">
  <div class="attribute-label" *ngIf="label">{{ 'images.label' | loc }}</div>
  <div class="photos">
    <span *ngFor="let photo of imagesWithSizes">
      <app-image-preview-item
        [photoPath]="photo.storagePath"
        [size]="photo.size"
        [fileLocation]="fileLocation"
        [downloadContext]="downloadContext"
      ></app-image-preview-item>
    </span>
    <span *ngFor="let photo of imagesRawData">
      <app-image-preview-item [rawData]="photo.rawData" [size]="photo.size"></app-image-preview-item>
    </span>
  </div>
  <div *ngIf="label && images.length === 0">{{ 'images.empty' | loc }}</div>
</div>
